export const deleteQuiz = (payload?: any) => ({
    type: "@saga/DELETE_QUIZ",
    payload
});

